export default __webpack_public_path__ + "static/media/december.3a15fc02.jpg";